import { env } from "../../../config/env";
import { apiClient } from "../../config";

import {
  GetProductsResponse,
  GetProductResponse,
} from "../../interface/products.interface";

import {
  GetProductCategoriesResponse,
} from "../../interface/productcategories.interface";

/**
 * ============================================
 * 🛒 PUBLIC PRODUCTS SERVICE
 * ============================================
 */

class ProductsService {
  /**
   * 🛒 GET PRODUCTS
   */
  async getProducts(): Promise<GetProductsResponse> {
    const response = await apiClient.get<GetProductsResponse>(
      env.PRODUCTS.PUBLIC.BASE
    );

    return response.data;
  }

  /**
   * 📄 GET PRODUCT
   */
  async getProduct(id: string): Promise<GetProductResponse> {
    const response = await apiClient.get<GetProductResponse>(
      env.PRODUCTS.PUBLIC.ONE(id)
    );

    return response.data;
  }

  /**
   * 🧩 GET PRODUCT CATEGORIES
   */
  async getProductCategories(): Promise<GetProductCategoriesResponse> {
    const response = await apiClient.get<GetProductCategoriesResponse>(
      env.PRODUCT_CATEGORIES.PUBLIC
    );

    return response.data;
  }
}

export const publicProductsService = new ProductsService();